var _defs, _path, _path2, _polyline, _path3, _path4, _path5, _path6, _path7, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#1a242d;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-linecap:round;}.cls-1,.cls-3{stroke-width:0.9px;}.cls-2,.cls-4{stroke-width:0.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ara") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,20.32V17.37a1.14,1.14,0,0,1,1.13-1.13h6a1.13,1.13,0,0,1,1.13,1.13v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.43,19.15v1.11h2.73s1.32,1.81,2.59,0h3V19.15"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.44 20.47 8.44 22.18 16.73 22.15 16.73 20.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.66,22.48a.84.84,0,0,1-1.68,0h1.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.12,22.52a.84.84,0,0,1-1.68,0h1.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.81,16.1,10.69,1.8c0-.64.37-1.16.82-1.16h2.14c.46,0,.83.51.83,1.15V16.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.35,18.52A.64.64,0,0,1,11,17.8a.66.66,0,0,1,.62.72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.45,18.52a.64.64,0,0,1,.63-.72.68.68,0,0,1,.63.72"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.43,
    y1: 19.62,
    x2: 16.73,
    y2: 19.62
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.0d171a7a6531769fa9d908fae2544c9c.svg";
export { ForwardRef as ReactComponent };